module.exports = __webpack_public_path__ + "static/img/student_icon.ef2c4b02.png";